<template>
    <div class="threshold-format-options">
        <q-select
            v-model="color"
            :options="colorOptions"
            option-label="label"
            option-value="value"
            emit-value
            map-options
            :label="Translate('Format')"
            outlined
            dense
            class="full-width"
            bg-color="white"
            hide-bottom-space
            :error="hasColorError"
        >
            <template v-slot:option="scope">
                <q-item v-bind="scope.itemProps">
                    <q-item-section avatar>
                        <div class="color-swatch" :style="{ backgroundColor: scope.opt.value }"></div>
                    </q-item-section>
                    <q-item-section>
                        <q-item-label>{{ scope.opt.label }}</q-item-label>
                    </q-item-section>
                </q-item>
            </template>
            <template v-if="color" #prepend>
                <div class="color-swatch" :style="{ backgroundColor: color }"></div>
            </template>
        </q-select>
    </div>
</template>
    
<script>
    import { QSelect, QItem, QItemSection, QItemLabel } from 'quasar';
    import methods from '@/Shared/methods';

    export default {
        components: { QSelect, QItem, QItemSection, QItemLabel },
        // Declare so parent listeners are component emits (Vue 3); same pattern as filter_*.vue (CCDEV-18136).
        emits: ['thresholdFormatChanged'],
        data: function () {
            return {               
                color:'',                
                hasColorError: false,
            }
        },
        props: {
            defaultColor: null,
            EventBus: null
        },
        created() {
                this.color = this.defaultColor;     
            },
        watch: {
            
            'color': {
                handler() {
                    if(this.color !== this.defaultColor)
                        this.triggerValidation();

                    this.$emit('thresholdFormatChanged', {
                        color: this.color
                    });
                }
            }
        },
        computed:{
            colorOptions: function () {
                return [
                    { label: this.Translate("Green"), value: "#4AB574" },
                    { label: this.Translate("Orange"), value: "#E07A1A" },
                    { label: this.Translate("Red"), value: "#EF4A41" },
                ];
            },
            colorRules() {
                return [
                    v => !!v || this.Translate('Please select a value')
                ];
            },
        },        
        methods: {
            ...methods,
            triggerValidation() {
                this.hasColorError = false;
                for (const rule of this.colorRules) {
                    const result = rule(this.color);
                    if (typeof result === 'string') {
                        this.hasColorError = true;
                        break;
                    }
                }
            },
            validate() {
                this.triggerValidation();
                return !this.hasColorError;
            },
        }
    }
</script>

<style src="./threshold_row.css"></style>

<style scoped>
    .color-swatch {
        width: 20px;
        height: 20px;
        border-radius: 8px;
    }
</style>
